import {
    LOADING_TOGGLE_ACTION,
    GET_COMPANIES_SUCCESS,
    GET_COMPANIES_FAILED,
    GET_COMPANY_BY_ID_SUCCESS,
    GET_COMPANY_BY_ID_FAILED,
    CREATE_COMPANY_SUCCESS,
    CREATE_COMPANY_FAILED,
    UPDATE_COMPANY_SUCCESS,
    UPDATE_COMPANY_FAILED,
    DELETE_COMPANY_SUCCESS,
    DELETE_COMPANY_FAILED,
    GET_COMPANIES_FOR_SELECT_SUCCESS,
    CLEAR_CURRENT_COMPANY,
    CLEAR_ERRORS
} from "../actions/CompaniesActions";

const initialState = {
    listdata: [],
    data: {},
    selectOptions: [],
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 1,
        nextPage: null,
    },
    loading: false,
    error: null,
    success: null
};

const CompaniesReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                loading: action.payload,
                error: action.payload ? null : state.error
            };

        case GET_COMPANIES_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: action.payload.data || action.payload.companies || [],
                pagination: action.payload.pagination || state.pagination,
                error: null
            };

        case GET_COMPANIES_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                listdata: []
            };

        case GET_COMPANY_BY_ID_SUCCESS:
            const updatedObj = Object.fromEntries(
                Object.entries(action.payload).map(([key, value]) => [key, value === null ? '' : value])
            );
            return {
                ...state,
                loading: false,
                data: updatedObj,
                error: null
            };

        case GET_COMPANY_BY_ID_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: {}
            };

        case CREATE_COMPANY_SUCCESS:
            return {
                ...state,
                loading: false,
                success: 'Company created successfully',
                error: null,
                listdata: [action.payload, ...state.listdata]
            };

        case CREATE_COMPANY_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case UPDATE_COMPANY_SUCCESS:
            return {
                ...state,
                loading: false,
                success: 'Company updated successfully',
                error: null,
                data: action.payload,
                listdata: state.listdata.map(company => 
                    company.id === action.payload.id ? action.payload : company
                )
            };

        case UPDATE_COMPANY_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case DELETE_COMPANY_SUCCESS:
            return {
                ...state,
                loading: false,
                success: 'Company deleted successfully',
                error: null,
                listdata: state.listdata.filter(company => company.id !== action.payload)
            };

        case DELETE_COMPANY_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_COMPANIES_FOR_SELECT_SUCCESS:
            return {
                ...state,
                selectOptions: action.payload
            };

        case CLEAR_CURRENT_COMPANY:
            return {
                ...state,
                data: {},
                error: null,
                success: null
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                success: null
            };

        default:
            return state;
    }
};

export default CompaniesReducer;